/**
 * Environment variable utilities for Vite
 * Provides a convenient interface to access VITE_ prefixed environment variables
 */

/**
 * Environment variable getters
 * These provide type-safe access to Vite environment variables
 */
export const env = {
  get ENV() {
    return import.meta.env.VITE_ENV || 'development'
  },

  get CAPTCHA() {
    return import.meta.env.VITE_CAPTCHA || ''
  },

  get TURNSTILE_KEY() {
    return import.meta.env.VITE_TURNSTILE_KEY || ''
  },

  get RESIDEN_API_BASE_URL() {
    return import.meta.env.VITE_RESIDEN_API_BASE_URL || ''
  },

  get RESIDEN_API_LOGIN_URL() {
    return import.meta.env.VITE_RESIDEN_API_LOGIN_URL || import.meta.env.VITE_RESIDEN_API_BASE_URL || ''
  },

  get TINY_API_KEY() {
    return import.meta.env.VITE_TINY_API_KEY || ''
  },

  get PUSHER_KEY_SITE_1() {
    return import.meta.env.VITE_PUSHER_KEY_SITE_1 || ''
  },

  get PUSHER_KEY_SITE_2() {
    return import.meta.env.VITE_PUSHER_KEY_SITE_2 || ''
  },

  get PUSHER_KEY_SITE_3() {
    return import.meta.env.VITE_PUSHER_KEY_SITE_3 || ''
  },

  get PUSHER_KEY_CENTRAL() {
    return import.meta.env.VITE_PUSHER_KEY_CENTRAL || ''
  },

  get PUSHER_CLUSTER() {
    return import.meta.env.VITE_PUSHER_CLUSTER || ''
  },

  get PUSHER_CLUSTER_SITE_1() {
    return import.meta.env.VITE_PUSHER_CLUSTER_SITE_1 || ''
  },

  get PUSHER_CLUSTER_SITE_2() {
    return import.meta.env.VITE_PUSHER_CLUSTER_SITE_2 || ''
  },

  get PUSHER_CLUSTER_SITE_3() {
    return import.meta.env.VITE_PUSHER_CLUSTER_SITE_3 || ''
  },

  get PUSHER_CLUSTER_CENTRAL() {
    return import.meta.env.VITE_PUSHER_CLUSTER_CENTRAL || ''
  },

  get PUSHER_KEY_SITE_BEVERLY_HILLS() {
    return import.meta.env.VITE_PUSHER_KEY_SITE_BEVERLY_HILLS || import.meta.env.VITE_PUSHER_KEY_SITE_1 || ''
  },
}
